import React from 'react';
import { useNavigate } from 'react-router-dom';
//import { useAuth } from './contexts/AuthContext';
import { Zap, Sparkles, LogOut, ArrowRight, MessageSquare, Shield, Mic } from 'lucide-react';
import { useQuery, useAction,useMutation } from 'convex/react';
import { api } from './convex/_generated/api';


export default function Indexs() {
  const navigate = useNavigate();
  const sessionId = localStorage.getItem('session_id');
  //const { user, signOut, isAdmin } = useAuth();
  
  // ← get user from session
  const user = useQuery(api.users.getUserBySession,
    sessionId ? { sessionId } : "skip"
  );
  const logoutUser = useAction(api.mfa.logoutUser);

  const handleSignOut = async () => {
    if (user) {
      await logoutUser({ sessionId });
      localStorage.removeItem('session_id');
      navigate('/');
    } else {
      navigate('/auth');
    }
  };

  const features = [
    {
      icon: <MessageSquare size={24} color="#fff" />,
      title: 'Script Generator',
      description: 'Get ready-to-use scripts for any hard conversation — raise, breakup, toxic boss and more.',
    },
    {
      icon: <Shield size={24} color="#fff" />,
      title: 'Pushback Responses',
      description: 'Know exactly what to say when they push back. 4 responses per situation.',
    },
    {
      icon: <Mic size={24} color="#fff" />,
      title: 'Voice Playback',
      description: 'Listen to your script out loud before the conversation. Practice makes perfect.',
    },
  ];

  return (
    <div style={S.page}>
      <div style={S.glow1} />
      <div style={S.glow2} />

      <style>{`
        @keyframes fadeUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes pulse { 0%,100% { opacity: 0.3; } 50% { opacity: 0.6; } }
        .feature-card:hover { border-color: rgba(255,255,255,0.2) !important; transform: translateY(-4px); }
        .cta-btn:hover { transform: translateY(-2px); box-shadow: 0 10px 30px rgba(124,58,237,0.4); }
      `}</style>

      {/* Header */}
      <header style={S.header}>
        <div style={S.headerInner}>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <span style={{ fontSize: 20 }}>⚡</span>
            <span style={S.logoText}>SayIt</span>
            <span style={S.logoBeta}>BETA</span>
          </div>
          <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
            <button
              onClick={handleSignOut}
              style={S.signOutBtn}
            >
              <LogOut size={14} />
              {user ? 'Sign Out' : 'Sign In'}
            </button>
            <button
              onClick={() => navigate(user ? '/dashboard' : '/auth')}
              style={S.navBtn}
            >
              {user ? 'Open App →' : 'Get Started →'}
            </button>
          </div>
        </div>
      </header>

      {/* Hero */}
      <section style={S.hero}>
        <div style={{ ...S.badge, animation: "fadeUp 0.4s ease both" }}>
          <Sparkles size={14} color="#C8A96E" />
          <span>The exact words for hard conversations</span>
        </div>

        <h1 style={{ ...S.heroTitle, animation: "fadeUp 0.5s ease both" }}>
          Say what needs<br />
          <em style={{ fontStyle: "italic", color: "#C8A96E" }}>to be said</em>
        </h1>

        <p style={{ ...S.heroSubtitle, animation: "fadeUp 0.6s ease both" }}>
          Tell me the situation. Get a ready-to-use script, email, or text —<br />
          tone variations, pushback responses, and a do/don't guide.
        </p>

        <div style={{ display: "flex", gap: 8, flexWrap: "wrap", justifyContent: "center", marginBottom: 40, animation: "fadeUp 0.7s ease both" }}>
          {["Ask for a Raise 💰", "End a Relationship 💔", "Handle Toxic Boss 🛡️", "Fight Rent Increase 📈", "Say No Guilt-Free 🙅", "Confront a Friend 💬"].map((s, i) => (
            <span key={i} style={S.tag}>{s}</span>
          ))}
        </div>

        <button
          className="cta-btn"
          onClick={() => navigate(user ? '/dashboard' : '/auth')}
          style={{ ...S.ctaBtn, animation: "fadeUp 0.8s ease both" }}
        >
          {user ? 'Open Generator' : 'Start Free'} <ArrowRight size={18} />
        </button>

        <p style={{ fontSize: 13, color: "rgba(255,255,255,0.3)", marginTop: 12 }}>
          Free for everyday · Premium packs for high-stakes
        </p>
      </section>

      {/* Stats */}
      <section style={S.stats}>
        {[["42", "Situations"], ["6", "Tones"], ["4", "Formats"], ["🔊", "Voice"]].map(([n, l], i) => (
          <div key={i} style={S.stat}>
            <strong style={S.statNum}>{n}</strong>
            <span style={S.statLabel}>{l}</span>
          </div>
        ))}
      </section>

      {/* Features */}
      <section style={S.features}>
        <h2 style={S.sectionTitle}>Everything you need</h2>
        <p style={S.sectionSubtitle}>Scripts that feel human, not robotic</p>
        <div style={S.featureGrid}>
          {features.map((f, i) => (
            <div key={i} className="feature-card" style={{ ...S.featureCard, transition: "all 0.2s" }}>
              <div style={S.featureIcon}>{f.icon}</div>
              <h3 style={S.featureTitle}>{f.title}</h3>
              <p style={S.featureText}>{f.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section style={S.ctaSection}>
        <h2 style={S.ctaTitle}>Ready to say it?</h2>
        <p style={S.ctaSubtitle}>
          Join people who stopped overthinking and started saying what needed to be said.
        </p>
        <button
          className="cta-btn"
          onClick={() => navigate(user ? '/dashboard' : '/auth')}
          style={S.ctaBtn}
        >
          {user ? 'Open Generator' : 'Start Free Today'} <ArrowRight size={18} />
        </button>
      </section>

      {/* Footer */}
      <footer style={S.footer}>
        <div style={{ fontFamily: "'Playfair Display', serif", fontSize: 18, fontWeight: 700, color: "#2a2a35", marginBottom: 8 }}>⚡ SayIt</div>
        <p style={{ fontSize: 13, color: "#252525" }}>Say what needs to be said. Exactly.</p>
      </footer>
    </div>
  );
}

const S = {
  page: {
    width: "1900px",
    minHeight: "100vh",
    background: "#0C0C0E",
    color: "#E8E8EC",
    fontFamily: "'DM Sans', sans-serif",
    position: "relative",
    overflow: "hidden",
    paddingTop: 50,
  },
  glow1: {
    position: "fixed",
    top: -100, right: -100,
    width: 500, height: 500,
    background: "rgba(124,58,237,0.15)",
    borderRadius: "50%",
    filter: "blur(120px)",
    pointerEvents: "none",
  },
  glow2: {
    position: "fixed",
    bottom: -100, left: -100,
    width: 500, height: 500,
    background: "rgba(74,222,128,0.08)",
    borderRadius: "50%",
    filter: "blur(120px)",
    pointerEvents: "none",
  },
  header: {
    borderBottom: "1px solid #1E1E28",
    padding: "0 24px",
    position: "sticky",
    top: 0,
    background: "rgba(12,12,14,0.96)",
    backdropFilter: "blur(16px)",
    zIndex: 100,
  },
  headerInner: {
    maxWidth: 960,
    margin: "0 auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    height: 60,
  },
  logoText: {
    fontFamily: "'Playfair Display', serif",
    fontSize: 22,
    fontWeight: 700,
    color: "#E8E8EC",
  },
  logoBeta: {
    fontSize: 10,
    fontWeight: 600,
    color: "#C8A96E",
    border: "1px solid #C8A96E",
    borderRadius: 4,
    padding: "2px 6px",
    letterSpacing: "0.08em",
  },
  navBtn: {
    background: "#C8A96E",
    border: "none",
    color: "#0C0C0E",
    cursor: "pointer",
    fontSize: 13,
    fontWeight: 600,
    padding: "8px 16px",
    borderRadius: 8,
    fontFamily: "'DM Sans', sans-serif",
  },
  signOutBtn: {
    background: "none",
    border: "1px solid #2a2a35",
    color: "#666",
    cursor: "pointer",
    fontSize: 13,
    padding: "8px 14px",
    borderRadius: 8,
    fontFamily: "'DM Sans', sans-serif",
    display: "flex",
    alignItems: "center",
    gap: 6,
  },
  hero: {
    maxWidth: 700,
    margin: "0 auto",
    padding: "100px 24px 60px",
    textAlign: "center",
    position: "relative",
    zIndex: 1,
  },
  badge: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    fontSize: 12,
    color: "#C8A96E",
    letterSpacing: "0.1em",
    textTransform: "uppercase",
    marginBottom: 24,
  },
  heroTitle: {
    fontFamily: "'Playfair Display', serif",
    fontSize: "clamp(42px, 7vw, 70px)",
    fontWeight: 900,
    lineHeight: 1.05,
    color: "#F0F0F5",
    marginBottom: 20,
  },
  heroSubtitle: {
    fontSize: 17,
    color: "#777",
    lineHeight: 1.75,
    marginBottom: 32,
  },
  tag: {
    fontSize: 12,
    color: "#444",
    border: "1px solid #1E1E28",
    borderRadius: 20,
    padding: "5px 12px",
  },
  ctaBtn: {
    background: "linear-gradient(90deg, #7c3aed, #4ade80)",
    color: "#fff",
    border: "none",
    borderRadius: 12,
    padding: "16px 40px",
    fontSize: 16,
    fontWeight: 600,
    cursor: "pointer",
    fontFamily: "'DM Sans', sans-serif",
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    transition: "all 0.2s",
  },
  stats: {
    display: "flex",
    justifyContent: "center",
    gap: 48,
    flexWrap: "wrap",
    padding: "40px 24px",
    borderTop: "1px solid #1E1E28",
    borderBottom: "1px solid #1E1E28",
    position: "relative",
    zIndex: 1,
  },
  stat: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 4,
  },
  statNum: {
    fontSize: 28,
    fontWeight: 800,
    color: "#F0F0F5",
    fontFamily: "'Playfair Display', serif",
  },
  statLabel: {
    fontSize: 11,
    color: "#444",
    textTransform: "uppercase",
    letterSpacing: "0.1em",
  },
  features: {
    maxWidth: 900,
    margin: "0 auto",
    padding: "80px 24px",
    textAlign: "center",
    position: "relative",
    zIndex: 1,
  },
  sectionTitle: {
    fontFamily: "'Playfair Display', serif",
    fontSize: 36,
    fontWeight: 700,
    color: "#F0F0F5",
    marginBottom: 12,
  },
  sectionSubtitle: {
    fontSize: 16,
    color: "#555",
    marginBottom: 48,
  },
  featureGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
    gap: 24,
  },
  featureCard: {
    background: "#13131A",
    border: "1px solid #1E1E28",
    borderRadius: 16,
    padding: "32px 24px",
    textAlign: "left",
  },
  featureIcon: {
    width: 48,
    height: 48,
    borderRadius: 12,
    background: "linear-gradient(135deg, #7c3aed, #4ade80)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 20,
  },
  featureTitle: {
    fontFamily: "'Playfair Display', serif",
    fontSize: 20,
    fontWeight: 700,
    color: "#F0F0F5",
    marginBottom: 8,
  },
  featureText: {
    fontSize: 14,
    color: "#666",
    lineHeight: 1.7,
  },
  ctaSection: {
    textAlign: "center",
    padding: "80px 24px",
    borderTop: "1px solid #1E1E28",
    position: "relative",
    zIndex: 1,
  },
  ctaTitle: {
    fontFamily: "'Playfair Display', serif",
    fontSize: 36,
    fontWeight: 900,
    color: "#F0F0F5",
    marginBottom: 16,
  },
  ctaSubtitle: {
    fontSize: 16,
    color: "#555",
    marginBottom: 32,
    maxWidth: 500,
    margin: "0 auto 32px",
  },
  footer: {
    borderTop: "1px solid #1E1E28",
    padding: "40px 24px",
    textAlign: "center",
  },
};